import Vue from 'vue'

var baseUrl = null
var isRefreshing = false

function getBase () {
  if (!baseUrl) {
    var result = window.location.href.substring(0, window.location.href.lastIndexOf('/#'))
    // Dev
    if (window.location.host.match(/localhost:8080/i)) {
      result = 'http://localhost:8081'
    }
    if (window.location.host.match(/127.0.0.1:8080/i)) {
      result = 'http://localhost:8081'
    }
    // Dev end
    baseUrl = result
  }
  return baseUrl
}

function setRefreshing (value) {
  isRefreshing = value
}

export default {
  getAccessToken () {
    return (window.localStorage && window.localStorage.getItem('accessToken') !== null)
    ? window.localStorage.getItem('accessToken') : null
  },
  getRefreshToken () {
    return (window.localStorage && window.localStorage.getItem('refreshToken') !== null)
    ? window.localStorage.getItem('refreshToken') : null
  },
  getJti () {
    return (window.localStorage && window.localStorage.getItem('jti') !== null)
    ? window.localStorage.getItem('jti') : null
  },
  getCurrentClient () {
    return (window.localStorage && window.localStorage.getItem('currentClient') !== null)
    ? window.localStorage.getItem('currentClient') : null
  },
  getLastLogin () {
    return (window.localStorage && window.localStorage.getItem('lastLogin') !== null)
    ? window.localStorage.getItem('lastLogin') : null
  },
  getIsExpired () {
    return (window.localStorage && window.localStorage.getItem('expires_in') !== null)
    ? Number.parseInt(window.localStorage.getItem('expires_in')) < new Date().getTime() : true
  },
  getIsRefreshing () {
    return isRefreshing
  },

  // getIsRefreshing () {
  //   return (window.localStorage && window.localStorage.getItem('isRefreshing') !== null)
  //   ? window.localStorage.getItem('isRefreshing') === 'true' : false
  // },
  saveToStorage (key, value) {
    // console.log('saveToStorage', key, value)
    if (window.localStorage) {
      if (value !== null) {
        window.localStorage.setItem(key, value)
      } else {
        window.localStorage.removeItem(key)
      }
    }
  },
  saveJwtInfo (data) {
    this.saveToStorage('accessToken', data ? data.access_token : null)
    this.saveToStorage('refreshToken', data ? data.refresh_token : null)
    this.saveToStorage('jti', data ? data.jti : null)
    this.saveToStorage('expires_in', data ? new Date().setSeconds(new Date().getSeconds() + data.expires_in) : null)
  },
  getBaseUrl () {
    return getBase()
  },
  openApiGetParams (uri, params, cb, errorCb) {
    Vue.axios.get(
      getBase() + uri,
      {params}
    )
    .then(responce => cb(responce.data))
    .catch(e => errorCb(e))
  },
  openApiGet (uri, cb, errorCb) {
    this.openApiGetParams(uri, {}, cb, errorCb)
  },
  openApiPost (uri, data, cb, errorCb) {
    Vue.axios.post(
      getBase() + uri,
      data
    )
    .then(responce => cb(responce.data))
    .catch(e => errorCb(e))
  },
  openApiPostConfig (uri, data, config, cb, errorCb) {
    Vue.axios.post(
      getBase() + uri,
      data,
      config
    )
    .then(responce => cb(responce.data))
    .catch(e => errorCb(e))
  },
// get token for registration
// curl register-app:secret@localhost:8081/oauth/token -d "grant_type=client_credentials&client_id=register-app&secret=secret&scope=registerUser"
// curl -H "Authorization: Bearer [ACCESS_TOKEN]" -H "Content-Type: application/json" -X POST localhost:8081/api/account/register -d '{"username":"user2", "password":"password"}'
  register (request, cb, errorCb) {
    const config = {
      auth: {
        username: 'register-app',
        password: 'none'
      }
    }
    var formData = new FormData()
    formData.append('grant_type', 'client_credentials')
    formData.append('client_id', config.auth.username)
    formData.append('secret', config.auth.password)
    formData.append('scope', 'registerUser')
    Vue.axios.post(getBase() + '/oauth/token',
      formData,
      config
    )
    .then(responce =>
      this.apiPostToken(
        responce.data.access_token,
        '/api/account/register',
        request,
        cb, errorCb))
    .catch(e => errorCb(e))
  },
// curl client-app:secret@localhost:8080/oauth/token -d "grant_type=password&username=user&password=password"
  login (request, cb, errorCb) {
    var self = this
    const cbF = (data) => {
      console.log('cbF')
      self.saveJwtInfo(data)
      setRefreshing(false)
      cb(null)
    }
    const config = {
      auth: {
        username: 'client-app',
        password: 'none'
      }
    }
    var formData = new FormData()
    formData.append('grant_type', 'password')
    formData.append('username', request.username)
    formData.append('password', request.password)
    formData.append('orgId', this.getCurrentClient())
    Vue.axios.post(getBase() + '/oauth/token',
      formData,
      config
    )
    .then(responce => cbF(responce.data))
    .catch(e => errorCb(e))
  },
  logout () {
    this.saveJwtInfo(null)
  },
  refreshInternal (cb, errorCb) {
    setRefreshing(true)
    var self = this
    const cbF = (data) => {
      console.log('cbF')
      self.saveJwtInfo(data)
      setRefreshing(false)
      cb()
    }
    const errorCbF = (e) => {
      setRefreshing(false)
      self.logout()
      errorCb({response: {data: {error: 'invalid_token'}, status: 401}})
    }
    const config = {
      auth: {
        username: 'client-app',
        password: 'none'
      }
    }
    if (!this.getRefreshToken() === 'null') {
      errorCbF(null)
    }
    var formData = new FormData()
    formData.append('grant_type', 'refresh_token')
    formData.append('jti', this.getJti())
    formData.append('refresh_token', this.getRefreshToken())
    formData.append('orgId', this.getCurrentClient())
    Vue.axios.post(getBase() + '/oauth/token',
      formData,
      config
    )
    .then(responce => cbF(responce.data))
    .catch(e => errorCbF(e))
  },
  checkExpiration (cb, errorCb) {
    var self = this
    const cbF = () => {
      if (!self.getIsExpired()) {
        cb(this)
      } else {
        setTimeout(() => cbF(), 60)
      }
    }
    if (this.getIsExpired() && this.getIsRefreshing() === false) {
      this.refreshInternal(cbF, errorCb)
    } else {
      cbF()
    }
  },
  refresh (request, cb, errorCb) {
    const cbF = (self) => self.refreshInternal(cb, errorCb)
    this.checkExpiration(cbF, errorCb)
  },
//     curl -H "Authorization: Bearer [ACCESS_TOKEN]" localhost:8080/api/hello
  apiGetInternal (uri, params, cb, errorCb) {
    var config = {
      params: params,
      headers: {
        Authorization: 'bearer ' + this.getAccessToken()
      }
    }
    Vue.axios.get(
      getBase() + uri,
      config
    )
    .then(responce => cb(responce.data))
    .catch(e => errorCb(e))
  },
  apiGetParams (uri, params, cb, errorCb) {
    console.log('apiGetParams', uri)
    const cbF = (self) => self.apiGetInternal(uri, params, cb, errorCb)
    this.checkExpiration(cbF, errorCb)
  },
  apiGet (uri, cb, errorCb) {
    this.apiGetParams(uri, {}, cb, errorCb)
  },
  apiPostToken (accessToken, uri, data, cb, errorCb) {
    var config = {
      headers: {
        Authorization: 'bearer ' + accessToken
      }
    }
    Vue.axios.post(
      getBase() + uri,
      data,
      config
    )
    .then(responce => cb(responce.data))
    .catch(e => errorCb(e))
  },
  apiPostInternal (uri, data, cb, errorCb) {
    this.apiPostToken(this.getAccessToken(), uri, data, cb, errorCb)
  },
  apiPost (uri, data, cb, errorCb) {
    const cbF = (self) => self.apiPostInternal(uri, data, cb, errorCb)
    this.checkExpiration(cbF, errorCb)
  },
  apiPutInternal (uri, data, cb, errorCb) {
    var config = {
      headers: {
        Authorization: 'bearer ' + this.getAccessToken()
      }
    }
    Vue.axios.put(
      getBase() + uri,
      data,
      config
    )
    .then(responce => cb(responce.data))
    .catch(e => errorCb(e))
  },
  apiPut (uri, data, cb, errorCb) {
    const cbF = (self) => self.apiPutInternal(uri, data, cb, errorCb)
    this.checkExpiration(cbF, errorCb)
  },
  apiDeleteInternal (uri, cb, errorCb) {
    var config = {
      headers: {
        Authorization: 'bearer ' + this.getAccessToken()
      }
    }
    Vue.axios.delete(
      getBase() + uri,
      config
    )
    .then(responce => cb(responce.data))
    .catch(e => errorCb(e))
  },
  apiDelete (uri, cb, errorCb) {
    const cbF = (self) => self.apiDeleteInternal(uri, cb, errorCb)
    this.checkExpiration(cbF, errorCb)
  },

  apiUploadInternal (uri, data, cb, errorCb) {
    var config = {
      headers: {
        Authorization: 'bearer ' + this.getAccessToken(),
        'Content-Type': undefined
      }
    }
    Vue.axios.post(
      getBase() + uri,
      data,
      config
    )
    .then(responce => cb(responce.data))
    .catch(e => errorCb(e))
  },
  apiUpload (uri, data, cb, errorCb) {
    const cbF = (self) => self.apiUploadInternal(uri, data, cb, errorCb)
    this.checkExpiration(cbF, errorCb)
  }

}



// WEBPACK FOOTER //
// ./src/api/server.js